<template>
  <div :class="['device-detail-maintenance-page', {'block-pop': popped}]">
    <!-- <img src="/static/images/device/sbwbjl.png" class="titl"> -->
    <div class="table-data" style="position:relative;height:calc(100% - 55px);">
      <div class="tab-switch">
        <span
          :class="[{'current': item==tabKey}]"
          v-for="item in tabData"
          v-text="item"
          @click="tabSwitch(item)"
        ></span>
      </div>
      <table v-if="tabKey=='维修记录'">
        <thead>
          <tr>
            <th width="90">时间</th>
            <!-- <th width="84">设备编号</th> -->
            <th v-show="popped" width="84">设备类型</th>
            <th width="80">故障原因</th>
            <th width="80">处理方法</th>
            <!-- <th width="84">处理人员</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in itemList">
            <td>
              <span
                v-text="$formatDateTime(new Date(item.BreakDownTime).getTime()/1000, 'yy/MM/dd')"
              ></span>
            </td>
            <!-- <td><span v-text="item.EquipmentCode"></span></td> -->
            <td v-show="popped">
              <span class="tdtxt" v-text="item.EquipmentType"></span>
              <div class="full-box" v-if="item.EquipmentType">
                <span class="txt" v-text="item.EquipmentType"></span>
              </div>
            </td>
            <td>
              <span class="tdtxt" v-text="item.BreakDowmReason"></span>
              <div class="full-box" v-if="item.BreakDowmReason">
                <span class="txt" v-text="item.BreakDowmReason"></span>
              </div>
            </td>
            <td>
              <span class="tdtxt" v-text="item.HandleMethod"></span>
              <div class="full-box" v-if="item.HandleMethod">
                <span class="txt" v-text="item.HandleMethod"></span>
              </div>
            </td>
            <!-- <td>
              <div class="tdtxt"><span v-for="(person, index) in JSON.parse(item.Handler)" v-text="person.Name+(index<JSON.parse(item.Handler).length-1?',':'')"></span></div>
              <div class="full-box" v-if="item.Handler">
                <div class="txt"><span v-for="(person, index) in JSON.parse(item.Handler)" v-text="person.Name+(index<JSON.parse(item.Handler).length-1?',':'')"></span></div>
              </div>
            </td>-->
          </tr>
        </tbody>
      </table>
      <table v-if="tabKey=='保养记录'">
        <thead>
          <tr>
            <th width="90">时间</th>
            <!-- <th width="84">设备编号</th> -->
            <th v-show="popped" width="84">设备类型</th>
            <th width="50">保养原因</th>
            <th width="84">保养类型</th>
            <!-- <th width="50">处理人员</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in itemList">
            <td>
              <span
                v-text="$formatDateTime(new Date(item.MaintenanceTime).getTime()/1000, 'yy/MM/dd')"
              ></span>
            </td>
            <!-- <td><span v-text="item.EquipmentCode"></span></td> -->
            <td v-show="popped">
              <span class="tdtxt" v-text="item.EquipmentType"></span>
              <div class="full-box" v-if="item.EquipmentType">
                <span class="txt" v-text="item.EquipmentType"></span>
              </div>
            </td>
            <td>
              <span class="tdtxt" v-text="item.MaintenanceReason"></span>
              <div class="full-box" v-if="item.MaintenanceReason">
                <span class="txt" v-text="item.MaintenanceReason"></span>
              </div>
            </td>
            <td>
              <span class="tdtxt" v-text="item.MaintenanceType"></span>
              <div class="full-box" v-if="item.MaintenanceType">
                <span class="txt" v-text="item.MaintenanceType"></span>
              </div>
            </td>
            <!-- <td>
              <span class="tdtxt" v-text="item.Handler"></span>
              <div class="full-box" v-if="item.Handler">
                <span class="txt" v-text="item.Handler"></span>
              </div>
            </td>-->
          </tr>
        </tbody>
      </table>
      <div class="page-container" style="position:absolute;bottom:40px;left:0;width:100%;">
        <v-pagination
          size="mini"
          :total="totalCount"
          :display="pageSize"
          :current-page="pageIndex"
          @pagechange="pageChange"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "@/components/widgets/Pagination";
export default {
  components: {
    "v-pagination": pagination
  },
  data() {
    let tabData = ["维修记录", "保养记录"];
    let todayTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000; //今天0点时间戳秒
    return {
      itemList: [],
      tabData: tabData,
      tabKey: tabData[0],
      popped: false,
      totalCount: 0,
      pageIndex: 1,
      pageSize: 7,
      // StartDate: this.$formatDateTime(todayTime - 30 * 24 *3600, 'yyyy-MM-dd'),
      // EndDate: this.$formatDateTime(null, 'yyyy-MM-dd'),
      EquipmentCode: ""
    };
  },
  props: ["StartTime", "EndTime"],
  watch: {
    popped(val) {
      if (!val) {
        this.pageSize = 7;
      } else {
        this.pageSize = 7 * 2;
      }
      this.pageChange(1);
    }
  },
  mounted() {
    console.log(this.StartTime);
    console.log(this.EndTime);
    window.EquipmentCode = "";
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //window.gbfc_setEquipmentCode = this.setEquipmentCode;
    window.gbfc_popupWindow = this.popupWindow;
    //初始化
    this.$initPage(this);
  },
  methods: {
    resetData(optionStr) {
      if (optionStr) {
        let options = JSON.parse(optionStr);
        if (options.StartDate) {
          //开始时间
          this.StartTime = options.StartDate;
        }
        if (options.EndDate) {
          //结束时间
          this.EndTime = options.EndDate;
        }
        if (options.EquipmentCode) {
          //设备编号
          this.EquipmentCode = options.EquipmentCode;
        }
        console.log("options", options, this.EquipmentCode);
      }
      //表格数据
      this.getItemList();
    },
    popupWindow(val) {
      this.popped = val;
    },
    tabSwitch(item) {
      this.tabKey = item;
      this.getItemList();
    },
    getItemList() {
      let self = this;
      let url = "";
      if (this.tabKey == "维修记录") {
        url = window.ApiHost1 + "/api/DataStatistical/Equip_BreakDown_Info";
        //url = window.ApiHost1+'/static/data/Equip_BreakDown_Info.json';
      } else {
        url = window.ApiHost1 + "/api/DataStatistical/Equip_Maintenance_Info";
        //url = window.ApiHost1+'/static/data/Equip_Maintenance_Info.json';
      }
      this.$handleRequest(
        url,
        {
          PageIndex: this.pageIndex,
          PageSize: this.pageSize,
          EquipmentCode: this.EquipmentCode,
          StartDate: this.StartTime,
          EndDate: this.EndTime,
          WareHouseCode: window.PYKWareHouseCode
        },
        "post",
        function(res) {
          //success
          console.log(res);
          self.itemList = res.retData.Rows;
          self.totalCount = res.retData.TotalCount;
        },
        function(res) {
          //fail
        }
      );
    },
    pageChange(pageIndex) {
      console.log("pageIndex", pageIndex);
      this.pageIndex = pageIndex;
      this.getItemList();
    }
  }
};
</script>

<style scoped>
th {
  height: 50px !important;
}
tr td {
  height: 40px !important;
}
table tr {
  border-bottom: 1px solid #ace5ff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/xiayan/device/DeviceDetailMaintenanceRecord.vue